/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, ViewEncapsulation } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet } from '@angular/material/bottom-sheet';
import { TranslateModule } from '@ngx-translate/core';
import { UserService } from 'src/app/user/services';
import { DragHandleComponent } from 'src/app/shared/drag-handle/drag-handle.component';
import { PassPortLogin } from '../../interfaces';
import { ToolsService, TranslationService } from 'src/app/services';

@Component({
  selector: "app-passport-login",
  imports: [
    CommonModule,
    TranslateModule,
    DragHandleComponent
  ],  
  standalone: true,
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None,
})

export class PassportLoginComponent {
    private _toolsService = inject(ToolsService);
    private _translationService = inject(TranslationService);
    protected readonly lang = this._translationService.selectedLanguage;
    private bottomSheet: MatBottomSheet = inject(MatBottomSheet);
    private userService: UserService = inject(UserService);
    public bottomSheetData: PassPortLogin = inject(MAT_BOTTOM_SHEET_DATA, { optional: true });
    
    login(){
      this.dismissBottomSheet();
      this.bottomSheet._openedBottomSheetRef?.afterDismissed().subscribe(() => this.userService.login());
    }

    dismissBottomSheet(){
        this.bottomSheet.dismiss();
    }

    protected openPassportGuide(): void {
      this._toolsService.openPassportGuide();
    }

}
